__turbopack_context__.v({
  "action": "Action-module-scss-module__c63dXW__action",
  "collapse": "Action-module-scss-module__c63dXW__collapse",
});
